import { Result } from '@standardnotes/domain-core';
export class GetTrustedPayload {
    constructor(decryptMessage) {
        this.decryptMessage = decryptMessage;
    }
    execute(dto) {
        const result = this.decryptMessage.execute({
            message: dto.payload.encrypted_message,
            sender: dto.sender,
            privateKey: dto.privateKey,
        });
        if (result.isFailed()) {
            return result;
        }
        const recipientUuid = result.getValue().data.recipientUuid;
        if (recipientUuid !== dto.ownUserUuid) {
            return Result.fail('Message is not for this user');
        }
        return result;
    }
}
